/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

Timestamps.js - Makes nice timestamps using a quite excessively nasty amount of code

*/

// Refactor all this a bit someday

window.addEventListener('DOMContentLoaded', timestampFmt);

function timestampFmt() {
  // set minute / hour / day MS values
  let msecPerMinute = 1000 * 60;
  let msecPerHour = msecPerMinute * 60;
  let msecPerDay = msecPerHour * 24;
  let timestamps = document.getElementsByClassName('ts');

  for (let ts of timestamps) {
    if (!ts.classList.contains('in-utc')) {
      let item = ts.title;
      item = item.replace(/ /, 'T') + 'Z';
      let date = new Date(item);
      let dateMsec = date.getTime();
      let today = new Date();
      let todayMsec = today.getTime();
      let interval = todayMsec - dateMsec;
      let days = Math.floor(interval / msecPerDay);
      interval = interval - days * msecPerDay;
      let hours = Math.floor(interval / msecPerHour);
      interval = interval - hours * msecPerHour;
      let minutes = Math.floor(interval / msecPerMinute);
      interval = interval - minutes * msecPerMinute;

      let ago = 'ago';
      let now = todayMsec - dateMsec;

      let months = (days * 30) / 900;
      months = Math.round(months);
      let years = (days * 365) / 133225;
      years = Math.floor(years);

      if (days == 0) {
        days = '';
      } else if (days == 1 && hours < 20) {
        days = 'yesterday';
        minutes = '';
        hours = '';
        ago = '';
      } else if (days == 1 && hours >= 20) {
        days = '2 days ';
        minutes = '';
        hours = '';
        ago = 'ago';
      } else if (days > 1 && days <= 30) {
        days = days + ' days ';
        minutes = '';
        hours = '';
      } else if (days > 30 && days <= 60) {
        days = '1 month ';
        minutes = '';
        hours = '';
      } else if (days > 60 && days <= 365) {
        days = months + ' months ';
        minutes = '';
        hours = '';
      } else if (days > 365 && days <= 390) {
        days = '1 year ';
        minutes = '';
        hours = '';
      } else if (days > 390 && days <= 420) {
        days = '1 year, 1 month ';
        minutes = '';
        hours = '';
      } else if (days > 420 && days <= 730) {
        days = '1 year, ' + (months - 12) + ' months ';
        minutes = '';
        hours = '';
      } else if (days > 730 && days <= 760) {
        days = years + ' years ';
        minutes = '';
        hours = '';
      } else if (days > 760 && days <= 790) {
        days = years + ' years, 1 month ';
        minutes = '';
        hours = '';
      } else if (days >= 790) {
        days = years + ' years, ' + (months - years * 12) + ' months ';
        minutes = '';
        hours = '';
      } else {
        days = days + ' days, ';
      }

      if (hours == 0) {
        hours = '';
      } else if (hours == 1 && minutes < 1) {
        hours = hours + ' hour ';
        minutes = '';
      } else if (hours == 1 && minutes >= 1) {
        hours = hours + ' hour, ';
      } else if (hours > 1) {
        minutes = '';
        hours = hours + ' hours ';
      } else {
        hours = hours + ' hours, ';
      }

      if (minutes == 1 && minutes != '') {
        minutes = minutes + ' minute ';
      } else if (minutes != '') {
        minutes = minutes + ' minutes ';
      } else if (now < 60000) {
        minutes = 'added just now';
        ago = '';
      }

      ts.innerText = days + hours + minutes + ago;
    }
  }
}

// Update TS every five minutes

setInterval(timestampFmt, 1 * 60 * 5000);
